<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAppStore } from './modules/app/stores/app.store'
import { useMaintenanceStore } from './modules/maintenance/stores/maintenance.store'
import { setDefaultOptions } from 'date-fns'
import { sv } from 'date-fns/locale'
import FooterBar from '@/modules/footerbar/components/FooterBar.vue'
import HeaderBar from './modules/headerbar/components/HeaderBar.vue'
import ToastMessage from './modules/toaster/components/ToastMessage.vue'
import SplashLoader from './shared/components/loader/SplashLoader.vue'
import NavigationPanel from './modules/navigation/components/NavigationPanel.vue'

const appStore = useAppStore()
const maintenanceStore = useMaintenanceStore()

setDefaultOptions({ locale: sv })
</script>

<template>
  <template v-if="appStore.isLoading">
    <SplashLoader :loading="appStore.isLoading" />
  </template>
  <template v-else>
    <template v-if="!maintenanceStore.isMaintenance">
      <HeaderBar />
      <NavigationPanel />
    </template>
    <RouterView />
    <ToastMessage />
    <footer>
      <FooterBar />
    </footer>
  </template>
</template>
